const PAYMENT_SERVER_URL = process.env.NODE_ENV === 'production'
	? 'https://fetusqgeq9.execute-api.us-east-2.amazonaws.com/default/SeasonalSetterCharge'
	: 'http://localhost:5000';

export default PAYMENT_SERVER_URL;